import {NgModule} from '@angular/core';
import {MultipleSelectFilterDataComponent} from "./multiple-select-filter-data.component";
import {ContentModule} from "../../../../shared/directives/content.module";
import {MultipleSelectFilterModule} from "../multiple-select-filter/multiple-select-filter.module";
import {ReactiveFormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";

@NgModule({
    declarations: [
        MultipleSelectFilterDataComponent,
    ],
    exports: [
        MultipleSelectFilterDataComponent,
        ContentModule,
    ],
    imports: [
        ReactiveFormsModule,
        MultipleSelectFilterModule,
        CommonModule,
    ]
})
export class MultipleSelectFilterDataModule {
}
